export default "__VITE_PUBLIC_ASSET__aae1e0a2__"